import type { Transaction } from '@shared/transactions-types';
import { createQuery, request } from '@luna/api';
import { logger } from '@luna/logger';
import { t } from '@luna/i18n';

import { getAttachmentUrl } from './getAttachmentUrl';

type Base64 = string;

export const [useAttachmentThumbnail] = createQuery({
    name: 'transactions/attachmentThumbnail',
    cacheKey: ({ id, attachment }) => (attachment?.hasThumbnail ? id : ''),
    payloadCreator: ({ id, attachment }: Transaction): Promise<Base64 | undefined> => {
        if (!attachment?.hasThumbnail) {
            return Promise.resolve(undefined);
        }

        const url = `${getAttachmentUrl(id)}/thumbnail`;
        const headers = { Accept: 'text/plain' };
        const options = { headers, skipParseJSON: true };

        return request<Response>(url, options)
            .then((result) => result.blob())
            .then((blob) => blob.text())
            .catch((error) => {
                logger.error(error);
                throw new Error(t('transaction.attachment.getThumbnailError'));
            });
    },
});
